





    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "productJiwa",
        components: {},
        mixins:[]
    })
    export default class productJiwa extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
